














import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { DashboardAPI } from '@/api/backend-client'
import { Dashboard } from '@/api/model/dashboard'

@Component
export default class ReportCrumb extends Vue {
    @Prop() readonly route!: Route
    @Prop() readonly last!: boolean
    dashboards: Dashboard[] = []

    async mounted(): Promise<void> {
        this.dashboards = await DashboardAPI.getAll()
    }

    get dashboardName(): string {
        const foundDashboard = this.dashboards.find(dashboardItem => dashboardItem.id === this.$route.params.dashboardId)

        return foundDashboard ? foundDashboard.title : ''
    }

    get componentClasses(): object {
        return {
            'crumb': true,
            'crumb--last': this.last,
        }
    }
}

